import { classNames } from '@utils/genUtils'
import React from 'react'
import { twMerge } from 'tailwind-merge'

interface Props {
  textClassNames?: string
  quoteClassNames?: string
  innerClassNames?: string
  content?: {
    subheader: string
    title: string
    text: string
    quote?: {
      cite: string
      quoteColor?: string
    }
  }
  textContent?: React.ReactNode
  altContent?: React.ReactNode
}

function SubSection(props: Props) {
  const { textClassNames, textContent, quoteClassNames, altContent, innerClassNames } = props

  return (
    <div className='flex flex-col w-full px-0 md:px-0'>
      <div className={twMerge('lfm2020-fontProcess__details flex flex-col col-start-2 col-span-2 md:col-start-2 md:col-span-12 md:flex md:flex-row md:my-8 md:mx-auto md:max-w-[708px] md:items-center xxl:max-w-[1000px] xxl:items-center', innerClassNames)}>
        <div className={twMerge('q1 text-xl z-2 md:m-0 md:pl-6 md:flex-[1_0_45%] xxl:mt-0 xxl:pl-0 xxl:text-2xl xxl:flex-[1_0_50%]', textClassNames)}>
          {textContent}
        </div>
        {altContent}
      </div>
    </div>
  )
}

export default SubSection
